<template lang="pug">
div.view_container
  Header
  AddVideo(
    v-if="!isSafari && !isIOS"
  )
  AddVideoTwilio(
    v-if="isSafari && !isIOS"
  )
  AddVideoWithFileUpload(
    v-if="isIOS"
  )
</template>

<script>
/* global gtag */
import config from '../appConfig'
import AddVideo from '../components/AddVideo'
import AddVideoTwilio from '../components/AddVideoTwilio'
import AddVideoWithFileUpload from '../components/AddVideoWithFileUpload'
import Header from '../components/Header'

export default {
  name: 'AddIntroVideoContainer',
  props: {
  },
  components: {
    AddVideo,
    AddVideoTwilio,
    AddVideoWithFileUpload,
    Header,
  },
  data () {
    return {
      isIOS: false,
      isSafari: false,
    }
  },
  apollo: {

  },
  methods: {

  },
  beforeMount: function () {
    this.isSafari = config.isSafari
    this.isIOS = config.isIOS
  },
  mounted: function() {
    // window.vue = this
    if (this.isSafari && !this.isIOS) {
      this.$toast.warning(
        "Video recording on safari is very slow, we recommend chrome:  https://www.google.com/chrome",
        {timeout: false}
      )
    }

    gtag('config', process.env.VUE_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID, {'page_path':  '/add_video'})
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {

}
</style>
